import { useParams } from "react-router-dom";

export const Newsletter = () => {
  const { id } = useParams();
  const path = `/newsletter/versions/newsletter_${id}.html`;
  return (
    <iframe
      sandbox="allow-scripts"
      title={"Newsletter"}
      src={path}
      style={{ width: "100vw", height: "100vh" }}
    />
  );
};
